module.exports = __webpack_public_path__ + "img/image.98da2de2.svg";